import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoft = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 21 21",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m1 1h9v9h-9z",
			fill: "#f25022"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m1 11h9v9h-9z",
			fill: "#00a4ef"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m11 1h9v9h-9z",
			fill: "#7fba00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m11 11h9v9h-9z",
			fill: "#ffb900"
		})
	]
});
export default SvgMicrosoft;
